import * as Yup from "yup";

export const AddUserSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required"),
  userName: Yup.string().trim().required("Required"),
  password: Yup.string().trim().required("Required"),
  roleId: Yup.mixed().required("Select Any Role"),
});

export const PasswordSchema = Yup.object().shape({
  password: Yup.string().trim().required("Password is required"),
});
